module.exports = __webpack_public_path__ + "static/media/listing-page-alibaug.923ed84d.jpg";